import React from 'react';

const SimpleLoader = ({ 
  size = 'md', 
  text = '', 
  className = '',
  color = '#948979' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div 
        className={`${sizeClasses[size]} border-2 border-gray-200 border-t-2 rounded-full simple-loader`}
        style={{ borderTopColor: color }}
      ></div>
      {text && (
        <span className="ml-3 text-sm font-medium" style={{ color: color }}>
          {text}
        </span>
      )}
    </div>
  );
};

export default SimpleLoader;